import { render } from "./LabResults.vue?vue&type=template&id=c45d4020&scoped=true"
import script from "./LabResults.vue?vue&type=script&lang=js"
export * from "./LabResults.vue?vue&type=script&lang=js"

import "./LabResults.vue?vue&type=style&index=0&id=c45d4020&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c45d4020"]])

export default __exports__